import { render, staticRenderFns } from "./TournamentsOverviewPage.vue?vue&type=template&id=2c6aaba6&scoped=true&"
import script from "./TournamentsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./TournamentsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./TournamentsOverviewPage.vue?vue&type=style&index=0&id=2c6aaba6&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6aaba6",
  null
  
)

export default component.exports